$(document).on('turbolinks:load', function() {
  $('.region').on('click', function() {
    $('.state').addClass('collapsed');
    $('.counties').removeClass('show');
  });

  // current location removed
  $('.js-regions').on('click', '.location-select', function(e){
    Location.updateList($(this));
    LocationSearch.clear('region');
  });

  // region/state/county selected
  $('#js-locations').on('click', '.js-location-options', function(){
    LocationSearch.search($(this));
    $(this).addClass('active');
  });

  // location selected
  $('#js-locations').on('click', '.js-location-select', function(){
    // remove any active that are now inactive
    var seletedLocation = `${$(this).attr('data-item-type')}-${$(this).attr('data-item-id')}`;

    $('.js-all-items').each(function() {
      console.log(`${$(this).attr('data-item-type')}-${$(this).attr('data-item-id')}` == seletedLocation)
      if (`${$(this).attr('data-item-type')}-${$(this).attr('data-item-id')}` != seletedLocation) {
        $(this).removeClass('list-group-item-success');
        $(this).attr('data-action', 'add');
        $(this).children('span.badge').remove();
      }
    });

    // remove single item if top level item selected "All states, all counties, all districts"
    if ($(this).hasClass('js-all-items')) {
      $('.js-single-item').each(function(){
        $(this).removeClass('list-group-item-success');
        $(this).attr('data-action', 'add');
        $(this).children('span.badge').remove();
      });
    }

    Location.updateList($(this));

    // toggle active and add/remove
    if ($(this).attr('data-action') == 'remove') {
      $(this).removeClass('list-group-item-success');
      $(this).attr('data-action', 'add');
      $(this).children('span.badge').remove();
    } else {
      $(this).addClass('list-group-item-success');
      $(this).attr('data-action', 'remove');
      $(this).append('<span class="badge badge-success float-right" style="font-size: 0.65rem;">Added!</span>');
    }
  })
});

var LocationSearch = {
  search: function(selectedLocation) {
    var locationId = selectedLocation.attr('data-item-id');
    var locationType = selectedLocation.attr('data-item-type');

    // clear previous results
    LocationSearch.clear(locationType);

    // show spinner
    LocationSearch.spinner(locationType);

    var searchUrl = $('#js-search-route').attr('data-url');
    searchUrl = searchUrl.replace('__LOCATION_ID__', locationId);
    searchUrl = searchUrl.replace('__LOCATION_TYPE__', locationType);

    $.ajax({
      type: "GET",
      url: searchUrl,
      success: function(data) {
        // clear spinner
        $('.js-spinner').remove();

        // update list
        LocationSearch.updateList(locationType, locationId, data.items, data.childType, data.seletedItems, data.parentSeleted, selectedLocation.attr('data-sequence'));
      }
    });
  },

  clear: function(listName) {
    $('.district').empty();
    $('.county').children('li').each(function(){
      $(this).removeClass('active');
    });

    if (listName != 'district') {
      $('.county').empty();
      $('.state').children('li').each(function(){
        $(this).removeClass('active');
      });
    }

    if (listName == 'state' || listName == 'region') {
      $('.state').empty();
      $('.region').children('li').each(function(){
        $(this).removeClass('active');
      });
    }
  },

  spinner: function(listName) {
    $(`.${listName}`).append('<div class="flex justify-center js-spinner"><i class="fas fa-lg fa-sync-alt fa-spin"></i></div>');
  },

  updateList: function(listName, listId, items, childList, seletedItems, parentSeleted, parentSequence) {
    var parentList = 'region';

    if (listName == 'county') {
      parentList = 'state';
    } else if (listName == 'district') {
      parentList = 'county';
      $(`.${listName}`).css('margin-top', parentSequence * 49 + 7);
    }

    // option for all items in list
    $(`.${listName}`).append(`<li class="list-group-item cursor-pointer js-all-items js-location-select ${parentSeleted ? 'list-group-item-success' : ''}" data-item-id="${listId}" data-item-type="${parentList}" data-action="${parentSeleted ? 'remove' : 'add'}">
                                All ${listName == 'county' ? 'counties' : listName + 's'}
                                ${parentSeleted ? '<span class="badge badge-success float-right" style="font-size: 0.65rem;">Added!</span>' : ''}
                              </li>`);

    var li = null;

    $.each(items, function(key, item) {
      li = `<li class="list-group-item cursor-pointer ${listName == 'district' && seletedItems.indexOf(item.id) >= 0 ? 'list-group-item-success' : ''} ${listName == 'district' ? 'js-location-select js-single-item' : 'js-location-options'}" data-item-id="${item.id}" data-item-type="${childList}" data-action="${seletedItems.indexOf(item.id) >= 0 ? 'remove' : 'add'}" data-sequence="${key+1}">
              ${listName == 'district' && seletedItems.indexOf(item.id) >= 0 ? '<span class="badge badge-success float-right" style="font-size: 0.65rem;">Added!</span>' : ''}
              ${listName == 'district' ? '' : '<div class="float-right"><span class="fa fa-chevron-right text-gray-700"></span></div>'}
              ${item.name}
            </li>`;

      $(`.${listName}`).append(li);
    })
  }
}

var Location = {
  updateList: function(listItem) {
    var updateUrl = $('#js-routes').attr('data-add-url');

    if (listItem.attr('data-action') == 'remove') {
      updateUrl = $('#js-routes').attr('data-remove-url');
    }

    updateUrl = updateUrl.replace('__LOCATION_TYPE__', listItem.attr('data-item-type'));
    updateUrl = updateUrl.replace('__LOCATION_ID__', listItem.attr('data-item-id'));

    $.ajax({
      type: "GET",
      url: updateUrl,
      success: function(data) {
        Location.updateListItems(data.locations);
      }
    });
  },

  updateListItems: function(allLocations) {
    $('#js-locations-list').empty();

    var statusColorList = {
      'region': 'warning',
      'state': 'secondary',
      'county': 'info',
      'district': 'primary'
    }

    var locationCount = 0;

    $.each(allLocations, function(locationType, locations) {
      $.each(locations, function(key, location) {
        locationCount++;
        $('#js-locations-list').append(`<span class="badge badge-${statusColorList[locationType]} ml-1 mb-2">${location[1]} <a class="location-select cursor-pointer" data-item-id="${location[0]}" data-item-type="${locationType}" data-action="remove"><span class="fas fa-times-circle"></span></a></span>`)
      });
    });

    if (locationCount == 0) {
      $('#js-locations-list').append('<span class="fas fa-ban"></span> None currently selected');

      // disable save button for initial setup steps
      $('#js-setup-save-btn').hide();
      $('#js-setup-save-btn-disabled').show();
    } else {
      // enable save button for initial setup steps
      $('#js-setup-save-btn').show();
      $('#js-setup-save-btn-disabled').hide();
    }
  }
}
